import { Component } from '@theme/component';

/**
 * @typedef {object} Refs
 * @property {HTMLElement} list
 *
 * @extends Component<Refs>
 */
export class AnchorNavigation extends Component {
  requiredRefs = ['list'];

  /** @type {HTMLElement[]} */
  items = [];

  /** @type {HTMLElement[]} */
  sections = [];
  connectedCallback() {
    super.connectedCallback();

    this.#initActive();

    if (!(this.refs.list instanceof HTMLElement)) {
      return;
    }

    this.items = Array.from(
      this.refs.list.querySelectorAll('[data-anchor]')
    );

    this.sections = this.items
      .map((item) => document.getElementById(item.dataset.anchor || ''))
      .filter((section) => section instanceof HTMLElement);

    this.refs.list.addEventListener('click', this.#onClick);
    window.addEventListener('scroll', this.#onScroll, { passive: true });

    this.#onScroll();
  }


  disconnectedCallback() {
    super.disconnectedCallback();

    if (!(this.refs.list instanceof HTMLElement)) return;

    this.refs.list.removeEventListener('click', this.#onClick);
    window.removeEventListener('scroll', this.#onScroll);
  }
  #initActive() {
    const first = this.items[0];
    if (first) {
      this.#setActive(first);
    }
  }


  /**
   * @param {MouseEvent} event
   */
  #onClick = (event) => {
    
    if (!(event.target instanceof HTMLElement)) {
      return;
    }
    
    const link = event.target.closest('[data-select-item]');
    
    if (!(link instanceof HTMLElement)) {
      return;
    }

    this.#setActive(link);
  };

  #onScroll = () => {
    const offset = 150;

    let currentSection = null;

    for (const section of this.sections) {
        const rect = section.getBoundingClientRect();

        if (rect.top <= offset) {
          currentSection = section;
        }
    }

    if (!currentSection) {
      return;
    }

    const activeButton = this.items.find(
        (item) => item.dataset.anchor === currentSection.id
    );

    if (activeButton) {
        this.#setActive(activeButton);
    }
   };

  /**
   * @param {HTMLElement} activeItem
   */
  #setActive(activeItem) {
    
    this.items.forEach((item) => {
        const isActive = item === activeItem;
        
        item.classList.toggle('is-active', isActive);
        
        if (isActive) {
          item.classList.remove('button-outline');
        } else {
          item.classList.add('button-outline');
        }
    });
  }
}

if (!customElements.get('anchor-navigation')) {
  customElements.define('anchor-navigation', AnchorNavigation);
}
